/**
 * AccessDenied — perimeter lockout for users without an admin role.
 *
 * v0.9.3 (Bill 2026-05-15) — Tightened info disclosure. Was previously
 * leaking required role names, the signed-in UPN, and the user's
 * current roles. Now shows only "User Not Authorized" + a Request
 * Access mailto link to the help desk. Sign-out remains available.
 *
 * The `user` prop is intentionally unused — kept in the signature so
 * RoleGate's call site doesn't need to change.
 */

import { useAuth } from '@/contexts/AuthContext';
import type { AuthUser } from '@/contexts/AuthContext';

const HELP_DESK_EMAIL = 'HelpDesk@mypcb.com';
const REQUEST_SUBJECT = 'Access Request — PCB Admin Panel';
const REQUEST_BODY =
  'Hi HelpDesk,%0D%0A%0D%0A' +
  'I need access to the PCB Admin Panel at https://admin.mypcb.com.%0D%0A%0D%0A' +
  'Please assign me an appropriate role and let me know once access is granted.%0D%0A%0D%0A' +
  'Thanks.';

export function AccessDenied({ user: _user }: { user: AuthUser }): JSX.Element {
  const { logout } = useAuth();
  const mailto = `mailto:${HELP_DESK_EMAIL}?subject=${encodeURIComponent(REQUEST_SUBJECT)}&body=${REQUEST_BODY}`;
  return (
    <div className="auth-gate">
      <div className="auth-gate__card">
        <h1 className="auth-gate__title">User Not Authorized</h1>
        <p className="auth-gate__body">
          You don&rsquo;t have access to this application.
        </p>
        <div className="auth-gate__actions">
          <a className="btn btn--primary" href={mailto}>
            Request Access
          </a>
          <button type="button" className="btn btn--ghost" onClick={() => void logout()}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
